/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {gqlQuery} from '../index';
import {RecentsResponse, RecentVariables} from '../models/recents';

export const RECENTS_QUERY = `
  query recentQuery ($pageSize: Int, $service: String, $objType: String, $cursor: String, $acrossSandbox: Boolean, $tillTimeStamp: Float){
    recent (pageSize: $pageSize, service: $service, objType: $objType, cursor: $cursor, acrossSandbox: $acrossSandbox, tillTimeStamp: $tillTimeStamp){
      recents {
        objId
        objName
        objType
        entityCode
        description
        objIcon
        serviceId
        redirectUrl
        clickTimestamp
        viewLink
        editLink
        status
        color
        createdBy
        lastModifiedBy
        modifiedOn
        sandboxName
        accessHistory
      }
      cursor
    }
  }
`;

export const getRecents = (vars: RecentVariables): Promise<RecentsResponse> =>
  gqlQuery<RecentsResponse, RecentVariables>(RECENTS_QUERY, vars);
